export const menuData = [
  {
    id: 1,
    name: "Short Black",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 2,
    name: "Macchiato",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 3,
    name: "Piccolo Latte",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 4,
    name: "Long Black",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 5,
    name: "Flat White",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 6,
    name: "Café Latte",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 7,
    name: "Cappuccino",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 8,
    name: "Café Mocha",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 9,
    name: "Hot Chocolate",
    category: "DRINK", // Hot Chocolate은 보통 Non-DRINK로 분류되기도 하지만, 여기서는 DRINK 섹션에 있었으므로 DRINK로 넣었습니다. 필요하면 변경해주세요.
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 10,
    name: "Matcha Latte",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 11,
    name: "Chai Latte",
    category: "DRINK",
    subcategory: "",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 12,
    name: "Taro Latte",
    category: "DRINK", // Taro Latte도 Non-DRINK에 속할 수 있지만, DRINK 섹션에 있었으므로 DRINK로 넣었습니다.
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 13,
    name: "Babyccino",
    category: "DRINK",
    subcategory: "BABYCINO",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 14,
    name: "Affogato",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 15,
    name: "Iced Long Black",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 16,
    name: "Iced Café Latte",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 17,
    name: "Iced DRINK",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 18,
    name: "Iced Café Mocha",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 19,
    name: "Butterscoth cream coffee",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 20,
    name: "Dalgona cream coffee",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 21,
    name: "Chestnut cream coffee",
    category: "DRINK",
    subcategory: "COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 22,
    name: "Honey Grapefruit Black Tea",
    category: "DRINK",
    subcategory: "SWEET TEA",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: true
  },
  {
    id: 23,
    name: "Lychee Chamomile Tea",
    category: "DRINK",
    subcategory: "SWEET TEA",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: true
  },

  {
    id: 24,
    name: "LOOSE LEAF TEA English Breakfast",
    category: "DRINK",
    subcategory: "LOOSE LEAF TEA",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 25,
    name: "Earl Grey",
    category: "DRINK",
    subcategory: "LOOSE LEAF TEA",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 26,
    name: "Chamomile",
    category: "DRINK",
    subcategory: "LOOSE LEAF TEA",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 27,
    name: "Peppermint",
    category: "DRINK",
    subcategory: "LOOSE LEAF TEA",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 28,
    name: "Lemon & Ginger",
    category: "DRINK",
    subcategory: "LOOSE LEAF TEA",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },
  {
    id: 29,
    name: "Green Tea",
    category: "DRINK",
    subcategory: "LOOSE LEAF TEA",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: false
  },

  {
    id: 30,
    name: "Iced Taro",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Drink/Iced Taro.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 31,
    name: "Iced Chai Latte",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Drink/Iced Chai Latte.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 32,
    name: "Iced Chocolate",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Drink/Iced Chocolate.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 33,
    name: "Matcha",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 34,
    name: "Strawberry Matcha",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 35,
    name: "Mango Matcha",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 36,
    name: "Chocolate Matcha",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 37,
    name: "Iced Lemon Tea",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 38,
    name: "Iced Peach Tea",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 39,
    name: "Misugaru",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: true
  },
  {
    id: 40,
    name: "Multigrain Latte",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_logo/buttered_noimage.webp",
    isNew: false,
    isHot: true,
    isIce: true
  },

  {
    id: 41,
    name: "Grapefruit Ade",
    category: "DRINK",
    subcategory: "ADE",
    image: "/assets/Buttered/Buttered_Menu_image/ade.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 42,
    name: "Green Grape Ade",
    category: "DRINK",
    subcategory: "ADE",
    image: "/assets/Buttered/Buttered_Menu_image/ade.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 43,
    name: "Lemon Ade",
    category: "DRINK",
    subcategory: "ADE",
    image: "/assets/Buttered/Buttered_Menu_image/ade.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },
  {
    id: 44,
    name: "Green Grape & Lemon Ade",
    category: "DRINK",
    subcategory: "ADE",
    image: "/assets/Buttered/Buttered_Menu_image/ade.webp",
    isNew: false,
    isHot: false,
    isIce: true
  },

  {
    id: 45,
    name: "Corn Cheese",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "", // 이미지 없음
    price: "9.1",
    isNew: false,
    isHot: false,
    isIce: false
  },
  {
    id: 46,
    name: "Garlic Creamcheese",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "",
    price: "8.1",
    isNew: false,
    isHot: false,
    isIce: false
  },

  {
    id: 50,
    name: "Vanilla Cream",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "",
    price: "8.1",
    isNew: false,
    isHot: false,
    isIce: false
  },
  {
    id: 51,
    name: "Ang Butter",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "",
    price: "9.1",
    isNew: false,
    isHot: false,
    isIce: false
  },
  {
    id: 52,
    name: "Coffee",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "",
    price: "7.1",
    isNew: false,
    isHot: false,
    isIce: false
  },
  {
    id: 53,
    name: "Matcha Cream",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "",
    price: "9.1",
    isNew: false,
    isHot: false,
    isIce: false
  },
  {
    id: 54,
    name: "Nutella",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "",
    price: "10.1",
    isNew: false,
    isHot: false,
    isIce: false
  },

  {
    id: 58,
    name: "Dubai Chewy Cookie",
    category: "BREAD",
    subcategory: "DESSERT",
    image: "/assets/Buttered/Buttered_Menu_image/duchonkoo.webp",
    price: "10.0",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 59,
    name: "Plain Croissant",
    category: "BREAD",
    subcategory: "CROISSANT",
    image: "/assets/Buttered/Buttered_Menu_image/plain_croissant.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 60,
    name: "Chocolate Croissant",
    category: "BREAD",
    subcategory: "CROISSANT",
    image: "/assets/Buttered/Buttered_Menu_image/chocolate_croissant.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 61,
    name: "Butter Rice Cake (5pcs)",
    category: "BREAD",
    subcategory: "RICE CAKE",
    image: "/assets/Buttered/Buttered_Menu_image/butterttuk.webp",
    price: "10.5",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 62,
    name: "Lemon Salt Bread",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "/assets/Buttered/Buttered_Menu_image/lemon.webp",
    price: "8.1",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 63,
    name: "Dubai Iced Chocolate",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_Menu_image/DubaiIcedChocolate2.webp",
    isNew: true,
    isHot: false,
    isIce: true
  },
  {
    id: 64,
    name: "Pistachio Cream Latte",
    category: "DRINK",
    subcategory: "NON COFFEE",
    image: "/assets/Buttered/Buttered_Menu_image/Pistachiocreamlatte.webp",
    isNew: true,
    isHot: false,
    isIce: true
  },
  {
    id: 65,
    name: "Buldak Chicken",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "/assets/Buttered/Buttered_Menu_image/buldak.webp",
    price: "10.1",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 66,
    name: "Teriyaki Chicken",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "/assets/Buttered/Buttered_Menu_image/Teriyakichicken2.webp",
    price: "10.1",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 67,
    name: "Baked Cheese Cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/dessert_image/Baked_Cheese_Cake.webp",
    price: "9.5",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 68,
    name: "Vanilla Fruits Cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/dessert_image/Vanilla_Fruits_Cake.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 69,
    name: "Chocolate Fruits Cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/dessert_image/Chocolate_Fruits_Cake.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 70,
    name: "Tiramisu",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/dessert_image/Tiramisu.webp",
    price: "11",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 71,
    name: "Baked Cheese Cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/Buttered_Cake_Menu/Baked Cheese Cake.webp",
    price: "66",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 72,
    name: "Buttered Signature red velvet cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/Buttered_Cake_Menu/Buttered Signature red velvet cake.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 73,
    name: "Fruit Chocolate Cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/Buttered_Cake_Menu/Fruit Chocolate Cake.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 74,
    name: "Orange Caracara Cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/Buttered_Cake_Menu/Orange Caracara Cake.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 75,
    name: "Tiramisu",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/Buttered_Cake_Menu/Tiramisu.webp",
    price: "72",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 76,
    name: "Vanilla Strawberry Cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/Buttered_Cake_Menu/Vanilla Strawberry Cake.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 77,
    name: "Yogurt grape cake",
    category: "CAKE",
    subcategory: "CAKE",
    image: "/assets/Buttered/Buttered_Cake_Menu/Yogurt grape cake.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 78,
    name: "Beton Salt Bread",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "/assets/Buttered/dessert_image/Beton_Salt_Bread.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 79,
    name: "Almond Croissant",
    category: "BREAD",
    subcategory: "CROISSANT",
    image: "/assets/Buttered/Buttered_Menu_image/Almond Croissant .webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 80,
    name: "Purple Sweet Potato",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "/assets/Buttered/Buttered_Menu_image/Purple Sweet Potato.webp",
    price: "9.1",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 81,
    name: "Prawn Croquette Potato Egg",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "/assets/Buttered/Buttered_Menu_image/Prawn Croquette Potato Egg.webp",
    price: "10.1",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 82,
    name: "Apple Cinnamon Salt Bread",
    category: "BREAD",
    subcategory: "SALTED & BUTTERED ROLL",
    image: "/assets/Buttered/Buttered_Menu_image/Apple Cinnamon Salt Bread.webp",
    price: "9.1",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 83,
    name: "Plain bagel with cream cheese",
    category: "BREAD",
    subcategory: "BAGEL",
    image: "/assets/Buttered/Buttered_Menu_image/creamchbg.png",
    price: "7.1",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 84,
    name: "Bagel Sandwich",
    category: "BREAD",
    subcategory: "BAGEL",
    image: "/assets/Buttered/Buttered_Menu_image/Bagel sandwich.webp",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 85,
    name: "Cookie Choux (Strawberry)",
    category: "BREAD",
    subcategory: "DESSERT",
    image: "/assets/Buttered/Buttered_Menu_image/strchrox.png",
    price: "9.8",
    isNew: true,
    isHot: false,
    isIce: false
  },
  {
    id: 86,
    name: "Cookie Choux (Chocolate)",
    category: "BREAD",
    subcategory: "DESSERT",
    image: "/assets/Buttered/Buttered_Menu_image/chocochrox.png",
    price: "9.8",
    isNew: true,
    isHot: false,
    isIce: false
  }
];
